import { validationUtils } from "@zickko/shared";
import * as React from "react";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = {
  value?: string;
  onChange: (value: string) => void;
  rows?: number;
  dataCy?: string;
  placeholder?: string;
  maxLength?: number;
  onPressEnter?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  customRef?: React.RefObject<HTMLTextAreaElement>;
} & FormItemProps<string>;

export const FormTextArea = (props: Props) => {
  const {
    value,
    onChange,
    validation = validationUtils.success,
    rows,
    dataCy,
    placeholder,
    maxLength,
    onPressEnter,
    onFocus,
    onBlur,
    customRef,
  } = props;
  return (
    <FormItemContainer<string> {...props}>
      <textarea
        ref={customRef}
        rows={rows ?? 3}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={validation.isValid ? "valid" : "invalid"}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter" && onPressEnter) onPressEnter();
        }}
        data-cy={dataCy}
        placeholder={placeholder}
        maxLength={maxLength}
      />
    </FormItemContainer>
  );
};
